module.exports = __webpack_public_path__ + "img/shield_done.a576c7a1.svg";